import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './endownership.json';

const Endownership = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Discuss digital ownership, subscriptions vs. buying, and the sharing economy. B2 level grammar, vocabulary, and reading exercises."
            level="B2"
            title="Meetings"
            image="/Images/ownership.webp"
            seoTitle="Free English Lesson Plans: End of Ownership"
            seoDescription="Discuss digital ownership, subscriptions vs. buying, and the sharing economy. B2 level grammar, vocabulary, and reading exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Endownership;


